/**
 * Cookie storage and retrieval.
 * @constructor
 * @param {string} name
 */
Foundation.Cookie = function (name) {
    /**
     * @public
     * @type {string}
     */
    this.name = name;

    /**
     * @private
     * @type {string}
     */
    this.value = "";

    /**
     * Flag for SSL only cookie.
     * @public
     * @type {boolean}
     */
    this.secure = (window.location.protocol === "https:");

    /**
     * Seconds until cookie should be purged.
     * @public
     * @type {number|null}
     */
    this.ttl = null;

    /**
     * Domain this cookie is available to.
     * @public
     * @type {string}
     */
    this.domain = Foundation.Cookie.siteDomainFromCurrentDomain();

    /**
     * @public
     * @type {string|null}
     */
    this.path = null;

    var encodedName = encodeURIComponent(this.name);
    var escapedName = encodedName.replace(/([^A-Za-z0-9])/g, "\\$1");
    var re = new RegExp(`${escapedName}=([^;]*)(?:;|$)`);
    var matches = document.cookie.match(re);
    if (matches) {
        this.value = decodeURIComponent(matches[1]);
    }
};

/**
 * Default domain to restrict cookies to.
 * @private
 * @return {string}
 */
Foundation.Cookie.siteDomainFromCurrentDomain = function () {
    var escapedSubdomains = [];
    for (var i = 0; i < Foundation.SUBDOMAINS.length; i++) {
        escapedSubdomains.push(Foundation.SUBDOMAINS[i].replace(/\./, "\\."));
    }

    var subdomainRegex = new RegExp(
        `^(?:${escapedSubdomains.join("|")})\\.`, "i"
    )

    return `.${document.domain.replace(subdomainRegex, "")}`;
};

/**
 * @return {string}
 */
Foundation.Cookie.prototype.getValue = function () {
    return this.value;
};

/**
 * @param {*} value
 * @return {Foundation.Cookie}
 */
Foundation.Cookie.prototype.setValueAndSave = function (value) {
    this.value = `${value}`;
    this.save();
    return this;
};

/**
 * Remove a cookie.
 */
Foundation.Cookie.prototype.erase = function () {
    this.value = "";
    var tmp = this.ttl;
    this.ttl = -100000;
    this.save();
    this.ttl = tmp;
};

/**
 * @private
 */
Foundation.Cookie.prototype.save = function () {
    var cookie = `${encodeURIComponent(this.name)}=`;
    cookie += `${encodeURIComponent(this.value)};`;
    cookie += `path=${this.path ? this.path : "/"};`;
    cookie += `domain=${this.domain};`;

    if (this.ttl) {
        var now = (new Date()).getTime();
        var expires = new Date(now + (this.ttl * 1000));
        cookie += `expires=${expires.toUTCString()};`;
    }

    if (this.secure) cookie += "secure;";

    document.cookie = cookie.replace(/;$/, "");
};
